<template>
  <div class="titleblock" :class="cssClass">
    <div v-if="suptitle" class="titleblock__suptitle">{{ suptitle }}</div>
    <component class="titleblock__title" v-bind:is="getMarkup"
      ><slot
    /></component>
    <div v-if="subtitle" class="titleblock__subtitle">{{ subtitle }}</div>
  </div>
</template>
<script>
export default {
  props: {
    alt: { default: false },
    suptitle: { default: false },
    subtitle: { default: false },
    markup: { default: "h1" },
    size: { default: null }
  },
  computed: {
    getMarkup() {
      if (["h1", "h2", "h3", "h4", "h5", "span"].includes(this.markup)) {
        return this.markup;
      } else {
        return "h1";
      }
    },
    getSize() {
      const defaultSize = "m";
      const sizeMarkup = {
        h1: "xl",
        h2: "l",
        h3: "m",
        h4: "s",
        h5: "xs",
        span: defaultSize
      };
      if (this.size === null) {
        return sizeMarkup[this.getMarkup];
      }
      const size = this.size.toLowerCase();
      if (["xs", "s", "m", "l", "xl"].includes(size)) {
        return size;
      } else {
        return defaultSize;
      }
    },
    cssClass() {
      const cssClasses = [];
      cssClasses.push("titleblock--" + this.getSize);
      if (this.alt !== false) {
        cssClasses.push("titleblock--alt");
      }
      return cssClasses.join(" ");
    }
  }
};
</script>
<style lang="scss">
.titleblock {
  margin-bottom: 1em;
  color: $title-color;
  &__title {
    margin-top: 0;
    @include font-bigtitle();
    .titleblock--alt & {
      @include font-title();
      text-transform: none;
    }
    margin-bottom: 0;
    font-size: 1em;
  }
  &--xl {
    font-size: 38px;
  }
  &--l {
    font-size: 32px;
  }
  &--m {
    font-size: 23px;
  }
  &--s {
    font-size: 16px;
  }
  &--xs {
    font-size: 13px;
  }
  &__suptitle {
    text-transform: uppercase;
    font-family: yrsa, serif;
    font-weight: 400;
    font-size: 0.5em;
    display: inline-flex;
    align-items: center;
    &::before,
    &::after {
      content: $pseudo-content;
      display: inline-block;
      width: 1em;
      height: 1px;
      margin: 0 0.3em;
      background: $title-color;
    }
  }
}
</style>
